import axios from 'axios'

import { apiURL, commonHeadersWeb, getCountryCode } from 'src/consumer/services'

/*
 * submitSessionRequest
 *
 * Posts a curated session request for a specific practitioner. The
 * backend saves it to the `session_requests` collection, pings the
 * support team on WhatsApp, and enqueues an SQS reminder so support
 * follows up even if they miss the first notification.
 *
 * The endpoint is public (no auth required) — anyone on the public
 * mentor page can submit.
 *
 * On success the server returns a short ticket id the user can
 * reference; we surface it back to them in the modal success state.
 */
export async function submitSessionRequest({
  mentorSlug,
  mentorId,
  fullName,
  mobile,
  email,
  urgency,
  sessionType,
  preferredWindows,
  reason,
}) {
  const slugOrId = mentorSlug || mentorId
  if (!slugOrId) {
    return { ok: false, message: 'Missing practitioner reference.' }
  }

  const payload = {
    mentorSlug: mentorSlug || null,
    mentorId: mentorId || null,
    fullName,
    mobile,
    email: email || null,
    urgency,
    sessionType,
    preferredWindows: preferredWindows || [],
    reason: reason || null,
    source: 'public-mentor-page',
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
  }

  const headers = {
    ...commonHeadersWeb,
    'ef-user-country-code': getCountryCode(),
    'ef-app-language':
      (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('languageCode')) ||
      'en',
  }

  try {
    const res = await axios.post(
      `${apiURL}/api/mentor/${encodeURIComponent(mentorSlug || mentorId)}/request-session`,
      payload,
      { headers },
    )
    // CommonResponse envelope: data.code is an int, data.data holds the payload.
    const code = res?.data?.code
    const isSuccess = res?.status === 200 && code >= 2000 && code < 3000
    if (isSuccess) {
      return {
        ok: true,
        ticketId:
          res?.data?.data?.sessionRequest?.ticketId ||
          res?.data?.data?.sessionRequest?.id ||
          null,
      }
    }
    return {
      ok: false,
      message: res?.data?.message || 'Could not submit your request.',
    }
  } catch (err) {
    return {
      ok: false,
      message:
        err?.response?.data?.message ||
        "We couldn't submit your request right now. Please try again in a moment.",
    }
  }
}
